module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-sativa-35da51ac74f5db22890a0194a72713a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/strains-sativa.png
 ** module id = 160
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/